import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const synchronizeElement = (elementId) => {
  const liveElement = getLiveElement(elementId);
  instance.driver.synchronizeElement(liveElement);
  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);

  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default synchronizeElement;
